// import qs from 'qs'
import axios, { Canceler } from "axios";
// import store from '@/store'
// import router from '@/router'
import baseUrl from "./base";
// import { ErrorMsg } from '@/utils/prompt'
// import {
//   // createConfirmDialogDefault,
//   createAlertDialogDefault,
//   createLoadingToast,
//   closeAllToast,
// } from '@/utils/ui-tools'

// axios.defaults.headers['Auth-Client-Role'] = 'teacher'
// axios.defaults.headers['Auth-Client-Type'] = 'pc'
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

const pendding: Array<{ url?: string; c?: Canceler }> = [];
const CancelToken = axios.CancelToken;
const serviceDebugger = process.env.VUE_APP_DEBUGGER === "true";
const service = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // config.cancelToken = new CancelToken((c) => {
    //   pendding.push({
    //     url: config.url,
    //     c,
    //   });
    // });
    // const token = store.getters['login/token']
    // if (token) {
    //   config.headers['Authorization'] = 'Bearer ' + token
    // }
    return config;
    // else if (config.url !== '/oauthserver/login/loginByWxMp') {
    //   console.log('api reject:', config.url)
    //   return Promise.reject('api url auth reject')
    // }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// async function createLoginDialog(message: string) {
//   try {
//     // await createAlertDialogDefault({
//     //   title: '提示',
//     //   // message: message || '登录失效',
//     //   message: '登录失效',
//     // })
//     // createLoadingToast()
//     store.commit('setLogout')
//     const data = store.dispatch('getUserToken')
//     console.log('api token status: ', data, message)
//     return data
//   } catch (e) {
//     console.log(e)
//     throw e
//   } finally {
//     // closeAllToast()
//   }
// }

// function createErrorDialog(title: string, message: string, isDebug = false) {
//   return new Promise((resolve, reject) => {
//     if (!isDebug || serviceDebugger) {
//       // createAlertDialogDefault({
//       //   title,
//       //   message,
//       // }).finally(() => {
//       //   reject(message)
//       // })
//     } else {
//       reject(message)
//     }
//   })
// }

// response interceptor
service.interceptors.response.use(
  ({ data, config }) => {
    // if (
    //   config['responseType'] === 'arraybuffer' ||
    //   config['responseType'] === 'blob'
    // ) {
    //   return data
    // }

    const { success, code, resultCode } = data;
    if (success && code === 0) {
      const i = pendding.findIndex((item) => (item.url = config.url));
      pendding.splice(i, 1);
      return data;
    }

    const resCode = code || resultCode;
    switch (resCode) {
      // case 500:
      //   // return createErrorDialog('500错误', message, true)
      //   return ErrorMsg(message)
      // case 5001:
      //   // return createErrorDialog('温馨提示', message)
      //   return ErrorMsg(message)
      // case -1100:
      // case -1101:
      // case 401: {
      //   pendding.forEach((item) => item.c())
      //   pendding = []
      //   if (store.getters['login/token'] && resCode !== 401) {
      //     await store.dispatch('login/logOut')
      //   }
      //   router.replace({ name: 'login' })
      //   ErrorMsg('身份已过期,请重新登录')
      //   return false
      // }
      default:
        return Promise.reject({ code: -1, data });
    }
  },
  (error) => {
    if (serviceDebugger) {
      if (error && error.message) {
        // createAlertDialogDefault({
        //   title: 'Debugger Error',
        //   message: error.message,
        // }).then((e) => console.log(e))
      }
    }
    return Promise.reject(error);
  }
);

export default service;
